// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"82":"AppCenter","286":"DevCoop","443":"about","776":"EcologicalCoop"}[chunkId] || chunkId) + "-legacy." + {"82":"e52e890a","286":"ac209871","443":"72c77de9","653":"95c6eb47","776":"4035ec9c"}[chunkId] + ".js";
};